<template>
  <div v-loading="loading" class="corp-wx-account-bind">
    <el-tabs v-if="sources.length" v-model="activeTab">
      <el-tab-pane label="第三方账号绑定" name="normal">
        <slot />
      </el-tab-pane>
      <el-tab-pane label="侧边栏企微共享绑定" name="shared">
        <div class="shared-bind-toolbar">
          侧边栏企微共享绑定：<el-button type="primary" size="small" icon="el-icon-plus" class="m-l-10" @click="openPhoneDialog()">新增</el-button>
        </div>
        <div class="shared-bind-list">
          <div v-for="item in bindList" :key="item.id" class="shared-bind-card">
            <div class="card-header">
              <span class="tag-wechat">企业微信</span>
              <div class="actions">
                <span class="action-btn bind-btn" role="button" tabindex="0" @click="openPhoneDialog(item)" @keydown.enter="openPhoneDialog(item)" @keydown.space.prevent="openPhoneDialog(item)">换绑</span>
                <span class="action-btn unbind-btn" role="button" tabindex="0" @click="unbind(item)" @keydown.enter="unbind(item)" @keydown.space.prevent="unbind(item)">解绑</span>
              </div>
            </div>
            <div class="card-content">
              <div class="user-info">
                <el-image :src="item.avatar || item.headImageUrl || item.bizWechatAvatar || ''" class="avatar">
                  <template slot="error">
                    <img src="~@/assets/image/imgloadError.png" class="avatar" />
                  </template>
                </el-image>
                <div class="name-info">
                  <span class="user-name">{{ item.nickName || item.userName || item.name || item.employeeName || item.bizWechatName || '未命名' }}</span>
                </div>
              </div>
              <div class="corp-name">{{ sourceName(item.sourceTenantId) }}</div>
            </div>
          </div>
          <div v-if="!bindList.length" class="shared-bind-empty">暂无共享绑定，请通过手机号绑定企微员工</div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <slot v-else />

    <el-dialog
      :title="form.relationId ? '侧边栏企微共享换绑' : '侧边栏企微共享绑定'"
      :visible.sync="phoneDialogVisible"
      width="420px"
      append-to-body
      :show-close="!submitting"
      :close-on-click-modal="false"
      :close-on-press-escape="!submitting"
    >
      <el-form ref="phoneForm" :model="form" :rules="rules" label-width="86px" size="small">
        <el-form-item label="共享企微" prop="sourceTenantId">
          <el-select v-model="form.sourceTenantId" :disabled="!!form.relationId || submitting" placeholder="请选择共享企微" style="width: 100%">
            <el-option v-for="item in sources" :key="item.sourceTenantId" :label="sourceName(item.sourceTenantId)" :value="item.sourceTenantId" />
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model.trim="form.phone" :disabled="submitting" maxlength="11" placeholder="请输入该企微员工的手机号" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" :disabled="submitting" @click="phoneDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitting" @click="submitPhoneBind">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSharedCorpWxSources,
  getSharedCorpWxBindList,
  bindSharedCorpWxByPhone,
  unbindSharedCorpWx
} from '@/api/privateArea/CRM'

export default {
  props: {
    userId: { type: [String, Number], required: true },
    phone: { type: String, default: '' },
    enabled: { type: Boolean, default: true }
  },
  data() {
    return {
      loading: false,
      activeTab: 'normal',
      sources: [],
      bindList: [],
      phoneDialogVisible: false,
      submitting: false,
      loadVersion: 0,
      form: { sourceTenantId: null, phone: '', relationId: null },
      rules: {
        sourceTenantId: [{ required: true, message: '请选择共享企微', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    bindingContext() {
      return `${this.enabled}:${this.userId}`
    }
  },
  watch: {
    bindingContext: {
      immediate: true,
      handler() {
        this.load()
      }
    }
  },
  methods: {
    async load() {
      const version = ++this.loadVersion
      this.activeTab = 'normal'
      this.phoneDialogVisible = false
      this.sources = []
      this.bindList = []
      if (!this.userId || !this.enabled) {
        this.loading = false
        return
      }
      this.loading = true
      try {
        const [sourceResult, listResult] = await Promise.all([
          getSharedCorpWxSources(),
          getSharedCorpWxBindList({ userId: this.userId })
        ])
        if (version !== this.loadVersion || this._isDestroyed) return
        const seen = new Set()
        this.sources = (sourceResult.data || []).filter(item => {
          const id = String(item.sourceTenantId)
          if (seen.has(id)) return false
          seen.add(id)
          return true
        })
        this.bindList = listResult.data || []
      } catch (error) {
        console.error('获取侧边栏企微共享绑定失败', error)
      } finally {
        if (version === this.loadVersion) this.loading = false
      }
    },
    sourceName(sourceTenantId) {
      const source = this.sources.find(item => String(item.sourceTenantId) === String(sourceTenantId))
      return (source && source.name) || `共享企微（${sourceTenantId}）`
    },
    openPhoneDialog(item) {
      this.form = {
        sourceTenantId: item ? item.sourceTenantId : (this.sources.length === 1 ? this.sources[0].sourceTenantId : null),
        phone: this.phone || '',
        relationId: item ? item.id : null
      }
      this.phoneDialogVisible = true
      this.$nextTick(() => this.$refs.phoneForm && this.$refs.phoneForm.clearValidate())
    },
    async refreshList() {
      const userId = this.userId
      const result = await getSharedCorpWxBindList({ userId })
      if (userId === this.userId && !this._isDestroyed) this.bindList = result.data || []
    },
    submitPhoneBind() {
      if (this.submitting) return
      this.$refs.phoneForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await bindSharedCorpWxByPhone({ ...this.form, userId: this.userId })
          this.$message.success(this.form.relationId ? '换绑成功' : '绑定成功')
          this.phoneDialogVisible = false
          await this.refreshList()
          this.$emit('change')
        } catch (error) {
          console.error('侧边栏企微共享绑定失败', error)
        } finally {
          this.submitting = false
        }
      })
    },
    unbind(item) {
      const userId = this.userId
      this.$delModal({
        tips: '是否确认解除该侧边栏企微共享绑定？',
        success: async () => {
          try {
            await unbindSharedCorpWx(item.id, { userId })
            this.$message.success('解绑成功')
            if (userId === this.userId) {
              await this.refreshList()
              this.$emit('change')
            }
          } catch (error) {
            console.error('解除侧边栏企微共享绑定失败', error)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.shared-bind-toolbar {
  display: flex;
  align-items: center;
  min-height: 32px;
}
.shared-bind-list {
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.shared-bind-card {
  width: calc(50% - 8px);
  flex-shrink: 0;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 10px;
  box-sizing: border-box;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .tag-wechat {
      border: 1px solid #409eff;
      color: #409eff;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
    }

    .actions {
      font-size: 14px;
      .action-btn {
        cursor: pointer;
        margin-left: 12px;
      }
      .bind-btn {
        color: #409eff;
      }
      .unbind-btn {
        color: #f56c6c;
      }
    }
  }

  .card-content {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    overflow: hidden;

    .user-info {
      display: flex;
      align-items: center;
      padding: 12px;
      justify-content: center;

      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 12px;
      }

      .name-info {
        display: flex;
        flex-direction: column;
        .user-name {
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }
      }
    }

    .corp-name {
      background: #f5f7fa;
      padding: 8px 16px;
      text-align: center;
      font-size: 13px;
      color: #909399;
    }
  }
}
.shared-bind-empty {
  width: 100%;
  padding: 28px 0;
  text-align: center;
  color: #909399;
}
</style>
